module.exports = __webpack_public_path__ + "img/bs_silo_0.297e31f9.png";